import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const MedicationHistoryPage = lazy(() => import("./MedicationHistoryPage"));

const MedicationHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <MedicationHistoryPage />
    </Suspense>
  );
};

export default MedicationHistoryPageLazy;
